import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppRouter } from '@/app/router'
import { queryClient } from '@/app/query-client'
import { AuthProvider } from '@/features/auth/auth-context'
import { RealtimeBridge } from '@/features/realtime/RealtimeBridge'
import { registerStaleChunkReload } from '@/lib/staleChunkReload'
import { ReleaseBanner } from '@/components/shell/ReleaseBanner'
import '@/styles/index.css'

registerStaleChunkReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RealtimeBridge />
        <AppRouter />
        <ReleaseBanner />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
